import { mapActions, mapState } from 'vuex';
import loaderMixin from '@/mixins/loader';
import Contract from '@/models/contract';
import contentLoaderMixin from '@/mixins/contentLoader';
import { isMarketSingle } from '@/utils/helpers';
import marketChangePrice
  from '@/components/market/market-change-price/market-change-price.vue'

export default {
  components: { marketChangePrice },
  mixins: [
    contentLoaderMixin,
    loaderMixin,
  ],
  props: {
    contractId: {
      type: Number,
      required: true,
    },
    market: {
      type: Object,
      required: true,
    },
    max: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapState('market', ['relatedContracts']),
    items() {
      const contracts = this.relatedContracts.map((i) => {
        const instance = new Contract(i);
        return {
          id: i.contractId,
          marketName: i.marketShortName || i.marketName,
          marketId: i.marketId,
          marketType: i.marketType,
          contractName: isMarketSingle(i) ? 'YES' : (i.contractShortName || i.contractName),
          image: i.contractImageSmallUrl || i.contractImageUrl,
          price: instance.changePriceAsCents,
          priceAsCents: instance.lastTradePriceAsCents,
          hasLastTradePrice: instance.hasLastTradePrice,
          lastClosePrice: instance.lastClosePrice,
          changePriceAsCents: instance.changePriceAsCents,
        };
      });
      return (this.max !== null) ? (contracts || []).slice(0, this.max) : (contracts || []);
    },
    title() {
      if (isMarketSingle(this.market)) {
        return `Related Contracts`
      }
      const contract = this.market.contracts.find(c => c.contractId === this.contractId);
      return contract ? `Related Contracts - ${contract.contractShortName || contract.contractName}` : 'Related Contracts';
    },
  },
  methods: {
    ...mapActions('market', ['getRelatedContracts', 'clearRelatedContracts']),
    itemLink(item) {
      return {
        name: 'market-details',
        params: { marketId: item.marketId },
        query: { contractId: item.id }
      }
    },
    loadContracts() {
      this.getRelatedContracts(this.contractId)
        .then(() => {
          this.isComponentReady = true;
      })
        .catch(() => {
          this.isComponentReady = true;
      })
    },
  },
  watch: {
    contractId: {
      handler () {
        this.loadContracts();
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.clearRelatedContracts();
  },
};



// WEBPACK FOOTER //
// ./src/components/related-contracts-horizontal-sushi/related-contracts-horizontal-sushi.js